import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=90f5b040&scoped=true&lang=pug&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=90f5b040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f5b040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90f5b040')) {
      api.createRecord('90f5b040', component.options)
    } else {
      api.reload('90f5b040', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=90f5b040&scoped=true&lang=pug&", function () {
      api.rerender('90f5b040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/components/Header.vue"
export default component.exports